export default {
    methods: {
        /*loadSeo(data) {
            let routePath = keepUpToSecondSlash(this.$route.path);

            function keepUpToSecondSlash(inputString) {
                const firstSlashIndex = inputString.indexOf('/');

                if (firstSlashIndex === -1) {
                    return inputString;
                }

                const secondSlashIndex = inputString.indexOf('/', firstSlashIndex + 1);

                if (secondSlashIndex === -1) {
                    return inputString;
                }
                return inputString.slice(0, secondSlashIndex + 1);
            }

            let seo = data.find((item) => item.url === routePath);
            if(routePath === '') {
                routePath = '/';
            }

            if (seo) {
                /!*document.title = seo.title;
                document.getElementsByTagName('meta')["description"].content = seo.description;*!/
            }
        },*/

        metaSeo() {
            let seo = this.seo.find(item => {
                return item.url === this.$route.matched[0].path;
            });
            if (seo) {
                return {
                    title: seo.title,
                    meta: {
                        name: 'description',
                        content: seo.description
                    }

                }
            }
        }
    },
    /*watch: {
        ['$root.seo'](val) {
            this.loadSeo(val);
        }
    }*/
}
